import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from './DefaultModal';
import TableContainer from '../TableContainer';
import DataTable from '../DataTable';
import usePagination10 from '../hooks/usePagination10';
import PaginationBar from '../PaginationBar';

function OrgaoFuncionarioListModal({ show, onClose, orgao, departamentos, onEdit, onDelete, onNovo }) {
  const [funcionarios, setFuncionarios] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [selecionado, setSelecionado] = useState(null);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal, resetDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show && orgao) {
      resetDefaultModal();
      setLoading(true);
      setFiltro('');
      setSelecionado(null);
      axios
        .get(`${API_BASE_URL.ORGAO_FUNCIONARIO}/orgao/${orgao.idOrgao}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => setFuncionarios(res.data))
        .catch(() => {
          setFuncionarios([]);
          showDefaultModal('error', 'Erro ao carregar funcionários!');
        })
        .finally(() => setLoading(false));
    } else {
      setFuncionarios([]);
    }
  }, [show, orgao, token]);

  const normalizeString = str =>
    (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase();

  const filtrados = funcionarios.filter(f =>
    normalizeString(f.nome || '').includes(normalizeString(filtro)) ||
    normalizeString(f.cpf || '').includes(normalizeString(filtro)) ||
    normalizeString(f.cargo || '').includes(normalizeString(filtro))
  );

  const totalItems = filtrados.length;
  const { setPagination } = usePagination10(totalItems);
  const pageData = filtrados.slice(
    setPagination.startIndex,
    setPagination.startIndex + setPagination.rowsPerPage
  );

  if (!show) return null;

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex="-1"
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
      >
        <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '90vw', height: '90vh' }}>
          <div className="modal-content" style={{ height: '100%', display: 'flex', flexDirection: 'column', borderRadius: '0.5rem', overflow: 'hidden' }}>
            <div
              className="modal-header text-white py-2"
              style={{
                background: 'linear-gradient(45deg, rgb(30, 27, 75) 0%, rgb(55, 48, 163) 100%)',
                border: 'none',
                flexShrink: 0,
              }}
            >
              <div className="d-flex align-items-center justify-content-between" style={{ width: '100%' }}>
                <h6 className="modal-title mb-0" style={{ fontSize: '0.80rem', lineHeight: 1 }}>
                  <i className="bi bi-people me-2"></i>
                  Funcionários — {orgao?.nome}
                </h6>
                <button
                  className="btn btn-link text-white p-0 mb-0"
                  onClick={onClose}
                  title="Fechar"
                  style={{ fontSize: '1rem', textDecoration: 'none' }}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>
            <div className="modal-body p-2" style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column' }}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex gap-2 flex-wrap">
                  <button className="btn btn-success btn-sm" onClick={onNovo} title="Novo funcionário">
                    <i className="bi bi-plus-circle me-1"></i>Novo
                  </button>
                  <button
                    className="btn btn-primary btn-sm"
                    disabled={!selecionado}
                    onClick={() => { if (selecionado) onEdit(selecionado); }}
                    title="Editar selecionado"
                  >
                    <i className="bi bi-pencil me-1"></i>Editar
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    disabled={!selecionado}
                    onClick={() => { if (selecionado) onDelete(selecionado); }}
                    title="Excluir selecionado"
                  >
                    <i className="bi bi-trash me-1"></i>Excluir
                  </button>
                </div>
                <div className="input-group input-group-sm" style={{ maxWidth: '250px' }}>
                  <span className="input-group-text">
                    <i className="bi bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Buscar funcionário..."
                    value={filtro}
                    onChange={e => setFiltro(e.target.value.toUpperCase())}
                  />
                </div>
              </div>
              <div style={{ flex: 1, overflow: 'auto' }}>
                <TableContainer isLoading={isLoading}>
                  <DataTable
                    style={{ fontSize: '0.8rem' }}
                    head={
                      <tr>
                        <th scope="col" className="px-2">Nome</th>
                        <th scope="col" className="px-2">CPF</th>
                        <th scope="col" className="px-2">Cargo</th>
                        <th scope="col" className="px-2">Departamento</th>
                        <th scope="col" className="px-2">Usuário</th>
                        <th scope="col" className="px-2">Situação</th>
                      </tr>
                    }
                  >
                    <tbody>
                      {pageData.length > 0 ? (
                        pageData.map(func => (
                          <tr
                            key={func.idFuncionario}
                            className={selecionado?.idFuncionario === func.idFuncionario ? 'table-primary' : ''}
                            style={{ cursor: 'pointer' }}
                            onClick={() => setSelecionado(selecionado?.idFuncionario === func.idFuncionario ? null : func)}
                          >
                            <td className="px-2">{func.nome}</td>
                            <td className="px-2">{func.cpf || '-'}</td>
                            <td className="px-2">{func.cargo || '-'}</td>
                            <td className="px-2">
                              {departamentos?.find(d => d.idDepartamento === func.idDepartamento)?.nome || '-'}
                            </td>
                            <td className="px-2">
                              <span className={`badge ${func.ehUsuario ? 'bg-info' : 'bg-secondary'}`}>
                                {func.ehUsuario ? 'Sim' : 'Não'}
                              </span>
                            </td>
                            <td className="px-2">
                              <span className={`badge ${func.situacao === 'ATIVO' ? 'bg-success' : 'bg-danger'}`}>
                                {func.situacao}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            {isLoading ? 'Carregando...' : 'Nenhum funcionário cadastrado.'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </DataTable>
                </TableContainer>
              </div>
              <PaginationBar setPagination={setPagination} />
            </div>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default OrgaoFuncionarioListModal;
